import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import type * as GraphQLTypes from '../../graphql/types.generated';
const defaultOptions = {} as const;

export type UnassignNotifiedPartyMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.UnassignNotifiedPartyInput;
}>;

export type UnassignNotifiedPartyMutationResult = { __typename?: 'Mutation' } & {
  bookingUnassignNotifiedParty?: GraphQLTypes.Maybe<
    { __typename?: 'UnassignNotifiedPartyPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const UnassignNotifiedPartyDocument = /*#__PURE__*/ gql`
  mutation unassignNotifiedParty($input: UnassignNotifiedPartyInput!) {
    bookingUnassignNotifiedParty(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;

/**
 * __useUnassignNotifiedPartyMutation__
 *
 * To run a mutation, you first call `useUnassignNotifiedPartyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignNotifiedPartyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignNotifiedPartyMutation, { data, loading, error }] = useUnassignNotifiedPartyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnassignNotifiedPartyMutation(
  baseOptions?: Apollo.MutationHookOptions<UnassignNotifiedPartyMutationResult, UnassignNotifiedPartyMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<UnassignNotifiedPartyMutationResult, UnassignNotifiedPartyMutationVariables>(
    UnassignNotifiedPartyDocument,
    options
  );
}
export type UnassignNotifiedPartyMutationHookResult = ReturnType<typeof useUnassignNotifiedPartyMutation>;
